import { DropDownSelectorValue } from 't-lib-ui/widgets';
import { PostTextTypes, PostTextType } from '../../schema-copy/feed-schema';

const label = (t: PostTextType) => t == 'none' ? 'No text badge' : t[0].toUpperCase() + t.slice(1);

/**
 * Dropdown options for a catalog entry's text badge override. The '' option means "detect from the
 * post stats" and names what the detection currently says (`detected`, undefined = no badge).
 */
export function textTypeOptions(detected: string | undefined): DropDownSelectorValue[] {
  const auto = `Auto (${detected ?? 'no badge'})`;
  return [
    { id: '', text: auto, searchTextLc: auto.toLowerCase() },
    ...PostTextTypes.map(t => ({ id: t, text: label(t), searchTextLc: label(t).toLowerCase() }))
  ];
}

/** Converts a dropdown id back into the override: '' (auto) is undefined. */
export const toTextType = (id: string) => (id || undefined) as PostTextType | undefined;
